module.exports = ".change-object-color {\n  font-size: 30px;\n  color: #808080;\n  opacity: 0.5;\n  pointer-events: none; }\n  .change-object-color.active {\n    opacity: 1;\n    pointer-events: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/services/proTools/ng-components/change-object-color/change-object-color.component.scss
// module id = ./src/app/services/proTools/ng-components/change-object-color/change-object-color.component.scss
// module chunks = main